import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'

import 'bootstrap/dist/css/bootstrap.min.css'
import './assets/css/style.css'

import VueTheMask from 'vue-the-mask'
import Swal from 'sweetalert2'

// import VueGtag from 'vue-gtag'

const app = createApp(App)

const pinia = createPinia()

// Passando o SweetAlert2 como global property para o Pinia
pinia.use(({ store }) => {
  store.$swal = Swal
})

// app.use(pinia).use(router).use(VueTheMask).use(VueGtag, { config: { id: 'G-ENFTMQKQQP'}, router}).mount('#app')
app.use(pinia).use(router).use(VueTheMask).mount('#app')
